import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * GA4 envía page_view automáticamente solo en la carga inicial. Como la
 * navegación entre páginas es del lado del cliente, aquí se envía un
 * page_view por cambio de ruta, sin duplicar el de la primera carga.
 */
export const usePageViewTracking = () => {
  const { pathname, search } = useLocation();
  const initial = useRef(true);

  useEffect(() => {
    if (initial.current) {
      initial.current = false;
      return;
    }
    const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
    if (typeof gtag !== 'function') return;

    gtag('event', 'page_view', {
      page_path: `${pathname}${search}`,
      page_location: window.location.href,
      page_title: document.title,
      language: pathname.startsWith('/en') ? 'en' : 'es',
    });
  }, [pathname, search]);
};
